module.exports = __webpack_public_path__ + "img/hero.e55377fc.png";